// ===== Request-a-quote modal focus start =====
(function () {
  const MODAL_ID = "raq_quote_form_modal";
  const TRIGGER = '[id^="sc-shopify-load-submit-popup"]';

  let opener = null;
  let openModal = null;
  let dismissing = false;

  function isShown(modal) {
    return modal.style.display !== "none" && modal.getClientRects().length > 0;
  }

  function upgrade(modal) {
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");

    const heading = modal.querySelector(".sc-modal-header h2");
    if (heading) {
      if (!heading.id) heading.id = MODAL_ID + "-title";
      modal.setAttribute("aria-labelledby", heading.id);
    }

    // The app closes on this element, but a bare span is no control: no tab stop
    // and no Enter or Space.
    const close = modal.querySelector(".sc-modal-close");
    if (!close || close.hasAttribute("role")) return;

    close.setAttribute("role", "button");
    close.setAttribute("tabindex", "0");
    close.setAttribute(
      "aria-label",
      window.accessibilityStrings?.close || "Close",
    );
    close.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      close.click();
    });
  }

  function onOpen(modal) {
    openModal = modal;
    opener?.setAttribute("aria-expanded", "true");
    upgrade(modal);
    // The cart drawer opens this and keeps its own trap, which would hold focus
    // behind the dialog it just put on screen.
    trapFocus(modal, getFocusableElements(modal)[0] || modal);
  }

  function onClose() {
    openModal = null;
    opener?.setAttribute("aria-expanded", "false");

    const back =
      opener && opener.isConnected && opener.getClientRects().length
        ? opener
        : null;
    removeTrapFocus(back);

    const drawer = document.querySelector("cart-drawer.active");
    if (drawer)
      trapFocus(drawer, back && drawer.contains(back) ? back : drawer);
  }

  function watch(modal) {
    if (modal.dataset.focusWatched) return;
    modal.dataset.focusWatched = "true";

    if (isShown(modal)) onOpen(modal);

    new MutationObserver(function () {
      const shown = isShown(modal);
      if (shown && openModal !== modal) onOpen(modal);
      else if (!shown && openModal === modal) onClose();
    }).observe(modal, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  // capture, because a microtask checkpoint runs between listeners: the app opens the
  // dialog in its own handler and the observer below sees it before a bubbling
  // listener here would have recorded what opened it
  document.addEventListener(
    "click",
    function (event) {
      const trigger = event.target.closest(TRIGGER);
      if (trigger) opener = trigger;
    },
    true,
  );

  // Escape has to reach the dialog before the drawer underneath it, which closes
  // itself on any Escape that reaches it.
  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key !== "Escape" || !openModal) return;
      event.stopPropagation();
      dismissing = true;
      openModal.querySelector(".sc-modal-close")?.click();
    },
    true,
  );

  document.addEventListener(
    "keyup",
    function (event) {
      if (event.key !== "Escape" || (!openModal && !dismissing)) return;
      // the dialog is already gone by the time this fires, and the drawer closes
      // on any Escape that reaches it
      dismissing = false;
      event.stopPropagation();
    },
    true,
  );

  // the button promises a dialog, so it says so and reports whether that dialog is up
  function stampTriggers() {
    document.querySelectorAll(TRIGGER).forEach((trigger) => {
      if (trigger.dataset.dialogWired) return;
      trigger.dataset.dialogWired = "true";
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.setAttribute("aria-expanded", "false");
    });
  }

  function scan() {
    stampTriggers();

    const modal = document.getElementById(MODAL_ID);
    if (modal) watch(modal);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
// ===== Request-a-quote modal focus end =====
